import { Entity } from 'apps/idl/src/model/entities/Entity';
import { EAvatarSize } from 'apps/idl/src/model/picture/EAvatarSize';
import { EDatabaseRole } from 'apps/idl/src/model/store/EDatabaseRole';
import { EntityBuilder } from 'apps/idl/src/services/security/EntityBuilder';
import { IDemandePreparationMedicaments } from 'apps/idl/src/model/IDemandePreparationMedicaments';
import { C_PREFIX_PHARMACIE } from '../app/app.constants';

export class DemandePreparationMedicamentsEntityBuilder extends EntityBuilder<IDemandePreparationMedicaments>{
	constructor() {
		super(
			(psModelId: string) => RegExp(C_PREFIX_PHARMACIE).test(psModelId),
			(poDemande: IDemandePreparationMedicaments) => new Entity(
				poDemande,
				`pharmas/${poDemande._id}/edit`,
				() => "Demande de préparation"
			),
			(psModelId: string) => "Demandes de préparation",
			EDatabaseRole.workspace,
			C_PREFIX_PHARMACIE,
			() => ({
				size: EAvatarSize.medium,
				icon: "clipboard"
			})
		);
	}
}